<dx-tag-box
  [dataSource]="dataSource"
  [displayExpr]="LookupResTypeEnum.Aciklama"
  [valueExpr]="valueExpr"
  [label]="labelMode === 'outside'?'':label"
  [value]="selectedValue | tagBoxValuePipe"
  [placeholder]="placeholder"
  (onValueChanged)="onValueChange($event)"
  [disabled]="disabled"
  [readOnly]="readOnly"
  [showSelectionControls]="showSelectionControls"
  (onMultiTagPreparing)="onMultiTagPreparing($event)"
  [maxDisplayedTags]="maxDisplayedTags"
  [showMultiTagOnly]="false"
  selectAllMode="allPages"
  [searchEnabled]="searchEnabled"
  [showDropDownButton]="showDropDownButton"
  [applyValueMode]="applyValueMode"
>
<dx-validator >
  <ng-container *ngIf="isRequired">
    <dxi-validation-rule
      type="required"
      [message]="
        label + ': Zorunludur'
      "
    >
    </dxi-validation-rule>
  </ng-container>
</dx-validator>
</dx-tag-box>
